import {BootstrapButton, BootstrapModal} from '../react-bootstrap'
import {bindState, pick, renderErrors, getImageUrlForProduct} from '../utils';

/* eslint globals: ["countries"] */

export function OrderDetails(order) {
    return <table className="table">
        <thead>
            <tr>
                <th>Item No.</th>
                <th>Image</th>
                <th>Product Name</th>
                <th>Unit Price</th>
                <th>Quantity</th>
                <th>Discount</th>
                <th className="last">Subtotal</th>
            </tr>
        </thead>
        <tbody>
            {
                order.items.map((p, i) => (
                    <tr key={ p.sku }>
                        <td>{ p.sku }</td>
                        <td>{ getImageUrlForProduct(p) ? <img src={getImageUrlForProduct(p, 'sm')} /> : null }</td>
                        <td>{ p.name }
                            {
                                p.attributes && (p.attributes.color || p.attributes.size) ?
                                    <div>
                                        {p.attributes.color ? <span style={{ marginRight: '1.5em'}}>Color: {p.attributes.color}</span> : null}
                                        {p.attributes.size ? <span>Size: {p.attributes.size}</span> : null}
                                    </div>
                                    : null
                            }
                            { p.notes ? <dl className="dl-horizontal order-item-notes"><dt>Notes:</dt><dd>{ p.notes }</dd></dl> : null }
                        </td>
                        <td>${ p.unit_price }</td>
                        <td>{ p.quantity }</td>
                        <td>${p.line_discount}</td>
                        <td className="last">${ p.line_price }
                        </td>
                    </tr>
                ))
            }
        </tbody>
        <tfoot>
            <tr key="_">
                <td className="subtotal" colSpan="7" style={{height: '4em'}}>
                    <dl className="dl-horizontal">
                        <dt>Subtotal:</dt>
                        <dd>${order.discounted_subtotal}</dd>
                        <dt>Shipping:</dt>
                        <dd>${ order.shipping_with_tax }</dd>
                        <hr />
                        <div>
                            <dt>Total:</dt>
                            <dd className="price">${ order.total }</dd>
                        </div>
                    </dl>
                </td>
            </tr>
        </tfoot>
    </table>
}

export class Checkout extends React.Component {
    constructor(props) {
        super(props);

        this.onPlaceOrder = this.onPlaceOrder.bind(this);
        this.recalculateOrder = this.recalculateOrder.bind(this);
        this.scrollToErrors = this.scrollToErrors.bind(this);

        this.bindState = bindState;

        var addresses = props.addresses;
        var billing_address = Object.assign({}, addresses.billing_address);
        var shipping_address = Object.assign({}, addresses.shipping_address);

        this.state = {
            order: this.props.order,
            ship_to_same_address: addresses.ship_to_same_address == null ? true : addresses.ship_to_same_address,
            billing_address: billing_address,
            shipping_address: shipping_address,
            shipping_method: 'FedEx',
            payment_method: null,
            remarks: ''
        };
    }

    componentWillUnmount () {
        this.xhr && this.xhr.abort();
    }

    recalculateOrder() {
        var data = pick(this.state, 'order', 'billing_address', 'ship_to_same_address', 'shipping_address', 'remarks', 'shipping_method', 'payment_method');
        $.postJSON('/checkout/calculate_order', data).done(data => {
            this.setState(data);
        });
    }

    scrollToErrors() {
        $('.text-danger').closest('.form-group, .payment-methods').addBack().get(0).scrollIntoView();
    }

    onPlaceOrder() {
        var data = pick(this.state, 'order', 'billing_address', 'ship_to_same_address', 'shipping_address', 'remarks', 'shipping_method', 'payment_method');
        $.postJSON('/checkout/place_order', data).done(data => {
            location.href = '/checkout/done?order_number=' + data.order_number;
        }).fail((xhr, textStatus, errorThrown) => {
            if (xhr.status === 400) {
                this.setState(xhr.responseJSON, this.scrollToErrors)
            } else if (xhr.status === 401) {
                this.setState({errors: {_overall_: ['You have not logged in. Please log in again.']}}, this.scrollToErrors);
            } else {
                this.setState({errors: {_overall_: ['Operation failed.']}}, this.scrollToErrors)
            }
        }).always((xhr, textStatus, errorThrown) => {
            this.xhr = null
        });
    }

    renderAddressErrors(address_field, field) {
        return renderErrors(this.state.errors && this.state.errors[address_field] && this.state.errors[address_field][field]);
    }

    renderAddressFields(type) {
        var address_field = type + '_address';
        var country = this.state[address_field].country;
        return (
            <div className={address_field + "-container"}>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-first_name"} className="control-label">First Name</label>
                            <input id={address_field + "-first_name"} type="text" className="form-control" placeholder="First Name" value={this.state[address_field].first_name} onChange={this.bindState(address_field + '.first_name')} />
                            {this.renderAddressErrors(address_field, 'first_name')}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-last_name"} className="control-label">Last Name</label>
                            <input id={address_field + "-last_name"} type="text" className="form-control" placeholder="Last Name" value={this.state[address_field].last_name} onChange={this.bindState(address_field + '.last_name')} />
                            {this.renderAddressErrors(address_field, 'last_name')}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-phone"} className="control-label">Phone</label>
                            <input id={address_field + "-phone"} type="text" className="form-control" placeholder="Phone" value={this.state[address_field].phone} onChange={this.bindState(address_field + '.phone')} />
                            {this.renderAddressErrors(address_field, 'phone')}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-email"} className="control-label">Email Address</label>
                            <input id={address_field + "-email"} type="text" className="form-control" placeholder="Email Address" value={this.state[address_field].email} onChange={this.bindState(address_field + '.email')} />
                            {this.renderAddressErrors(address_field, 'email')}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-country"} className="control-label">Country</label>
                            <select id={address_field + "-country"} className="form-control" value={country} onChange={this.bindState(address_field + '.country', v=> { this.state[address_field].subdivision = ''; return v;}, this.recalculateOrder)}>
                                <option key="_" value=""></option>
                                { countries.map(c => <option key={c.code} value={c.code}>{c.name}</option>) }
                            </select>
                            {this.renderAddressErrors(address_field, 'country')}
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor={address_field + "-street1"} className="control-label">Address</label>
                    <input id={address_field + "-street1"} type="text" className="form-control" placeholder="Street Address" value={this.state[address_field].street1} onChange={this.bindState(address_field + '.street1')} />
                    {this.renderAddressErrors(address_field, 'street1')}
                </div>
                <div className="form-group">
                    <input id={address_field + "-street2"} type="text" className="form-control" placeholder="Apartment, suite, unit, etc. (optional) " value={this.state[address_field].street2} onChange={this.bindState(address_field + '.street2')} />
                    {this.renderAddressErrors(address_field, 'street2')}
                </div>
                <div className="form-group">
                    <label htmlFor={address_field + "-city"} className="control-label">City</label>
                    <input id={address_field + "-city"} type="text" className="form-control" placeholder="City" value={this.state[address_field].city} onChange={this.bindState(address_field + '.city')} />
                    {this.renderAddressErrors(address_field, 'city')}
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-subdivision"} className="control-label">State / Province</label>
                            { /^(?:BR|CA|IT|MX|US)/.test(country || '') ?
                                <select id={address_field + "-subdivision"} className="form-control" value={this.state[address_field].subdivision} onChange={this.bindState(address_field + '.subdivision')}>
                                    <option key="_" value=""></option>
                                    { _states[country].map(ln => <option key={country + '-' + ln[0]} value={ln[0]}>{ln[1]}</option>) }
                                </select>
                                    :
                                    <input id={address_field + "-subdivision"} type="text" className="form-control" placeholder="State / Province" value={this.state[address_field].subdivision} onChange={this.bindState(address_field + '.subdivision')} />
                            }
                            {this.renderAddressErrors(address_field, 'subdivision')}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-postal_code"} className="control-label">Postcode / ZIP</label>
                            <input id={address_field + "-postal_code"} type="text" className="form-control" placeholder="Postcode / ZIP" value={this.state[address_field].postal_code} onChange={this.bindState(address_field + '.postal_code')} />
                            {this.renderAddressErrors(address_field, 'postal_code')}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render () {
        var items = this.state.order.items;
        var totalQuantities = items.reduce((prev, curr) => prev + curr.quantity, 0);

        return (
            <div className="row">
                <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
                    <div className="checkout-container">
                        <h3>Checkout</h3>
                        <hr />

                        {renderErrors(this.state.errors && this.state.errors._overall_)}

                        <div className="billing-address">
                            <h4><span className="ordered-number">1</span> Billing Address</h4>
                            { this.renderAddressFields('billing') }
                            <h4 className={'checkbox' + (this.state.ship_to_same_address ? '' : ' checked')}>
                                <label><input type="checkbox" checked={!this.state.ship_to_same_address} onChange={this.bindState('ship_to_same_address', v => !v)} />Ship to a different address?
                                </label>
                            </h4>
                            { this.renderAddressFields('shipping') }
                        </div>

                        <div className="row order-notes">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label htmlFor="remarks" className="control-label">Order Notes</label>
                                    <textarea id="remarks" type="text" className="form-control" placeholder="Order Notes" value={this.state.remarks} onChange={this.bindState('remarks')} maxLength="1000"/>
                                    {renderErrors(this.state.errors && this.state.errors.remarks)}
                                </div>
                            </div>
                        </div>

                        <div className="shipping-methods">
                            <h4><span className="ordered-number">2</span> Shipping Method</h4>
                            {renderErrors(this.state.errors && this.state.errors.shipping_method)}
                            <div>
                                <div className="radio">
                                    <label>
                                        <input name="shipping_method" type="radio" value="FedEx" checked={this.state.shipping_method === 'FedEx'} onChange={this.bindState('shipping_method')} />FedEx Express Mainly or Others (${this.state.order.shipping_with_tax})
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="payment-methods">
                            <h4><span className="ordered-number">3</span> Payment Method</h4>
                            {renderErrors(this.state.errors && this.state.errors.payment_method)}
                            <div>
                                <div className="radio clearfix">
                                    <label>
                                        <img className="pull-right" src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppmcvdam.png" alt="Credit Card Badges" />
                                        <input name="payment_method" type="radio" value="paypal" checked={this.state.payment_method === 'paypal'} onChange={this.bindState('payment_method') } />PayPal
                                        <div className="option-help">
                                            Pay via PayPal; you can pay with your credit card if you don't have a PayPal account.
                                        </div>
                                    </label>
                                </div>
                                <div className="radio">
                                    <label>
                                        <input name="payment_method" type="radio" value="west_union" checked={this.state.payment_method === 'west_union'} onChange={this.bindState('payment_method')} />West Union
                                        <div className="option-help">
                                            <dl className="dl-horizontal dl-horizontal-90">
                                                <dt>First Name:</dt><dd>Changhui</dd>
                                                <dt>Last Name:</dt><dd>Dong</dd>
                                                <dt>Add:</dt><dd>Jiang Dong Si Qu, Yiwu City, Zhejiang Province, China 322000</dd>
                                                <dt>Tel:</dt><dd>579-8213146</dd>
                                            </dl>

                                        </div>
                                    </label>
                                </div>
                                <div className="radio">
                                    <label>
                                        <input name="payment_method" type="radio" value="bacs" checked={this.state.payment_method === 'bacs'} onChange={this.bindState('payment_method')} />Bank Transfer
                                        <div className="option-help">
                                            <dl className="dl-horizontal dl-horizontal-150">
                                                <dt>Beneficiary Name:</dt><dd>Dong Changhui</dd>
                                                <dt>Beneficiary Address:</dt><dd>Jiang Dong Si Qu, Yiwu City, Zhejiang Province, China</dd>
                                                <dt>Account No.:</dt><dd>4530030-0188-109312-1</dd>
                                                <dt>Bank:</dt><dd>BANK OF CHINA YIWU SUB-BRANCH</dd>
                                                <dt>Bank swift no.:</dt><dd>BKCHCNBJ910</dd>
                                                <dt>Bank Add:</dt><dd>NO.500 CHOUZHOU NORTH ROAD, YIWU, ZHEJIANG, China</dd>
                                            </dl>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="order-details">
                            <h4><span className="ordered-number">4</span> Order Details</h4>
                            { OrderDetails(this.state.order) }
                        </div>

                        <br />
                        <button className="btn btn-primary btn-place-order pull-right" onClick={this.onPlaceOrder}>Place order</button>
                    </div>
                </div>
            </div>
        );
    }
}
